import Image from "@Components/Image";
import styles from "./BookEarlySection.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";

const BookEarlyCards = ({
  imgSrc,
  subTitle,
  content,
  withFullWidth = false,
  dataTestId,
}: {
  imgSrc: string;
  subTitle: string;
  content: string;
  withFullWidth: boolean;
  dataTestId: string;
}) => {
  const { t } = useTranslationHook();
  return (
    <div className={styles.bookEarlyCardOuter} data-testid={dataTestId}>
      {withFullWidth && <div className={styles.radialGradientNew} />}
      <div className={styles.bookEarlyContainer}>
        <div className={styles.bookEarlyImg}>
          <Image src={imgSrc} height={36} width={36} />
        </div>
        <div className={styles.bookeEarlyContent}>
          <div className={styles.bookEarlySubtitle} data-testid="book-early-card-title">
            {t(subTitle)}
          </div>
          <div className={styles.bookEarlyText} data-testid="book-early-card-content">
            {t(content)}
          </div>
        </div>
      </div>
    </div>
  );
};
export default wrapperHOC(BookEarlyCards, {
  componentName: "BookEarlyCards-BookEarlySection-SearchPage",
  showForChina: true,
});
